export const addEventFormFeild = [
	{
		type: 'hidden',
		formControlName: 'id',
	},
	{
		type: 'email',
		title: `Creator's / Editor's Email *`,
		placeholder: 'Enter User Email',
		formControlName: 'email',
		required: true,
		errorsMsg: [
			{ type: 'required', message: 'Email is required' },
			{ type: 'pattern', message: 'Enter valid email' },
		],
	},
	{
		type: 'email',
		title: 'Speaker Email',
		placeholder: 'Enter Speaker Email',
		formControlName: 'speakerEmail',
		errorsMsg: [{ type: 'pattern', message: 'Enter valid email' }],
	},
	{
		type: 'email',
		title: 'Moderator Email',
		placeholder: 'Enter Moderator Email',
		formControlName: 'moderatorEmail',
		errorsMsg: [{ type: 'pattern', message: 'Enter valid email' }],
	},
	{
		type: 'select',
		title: 'Communities',
		placeholder: 'Select Communities',
		formControlName: 'communities',
	},
	{
		type: 'select',
		title: 'Event Tags',
		placeholder: 'Select Tags',
		formControlName: 'tagOnTheEvent',
		required: false,

		errorsMsg: [{ type: 'required', message: 'Community is required' }],
	},
	{
		type: 'url',
		title: 'Event Image Link',
		formControlName: 'eventImage',
		placeholder: 'Enter event image link',

		errorsMsg: [{ type: 'pattern', message: 'Enter valid url' }],
	},
	{
		type: 'text',
		title: 'Title *',
		placeholder: 'Event Title',
		formControlName: 'title',
		required: true,
		maxLength: 500,
		errorsMsg: [
			{ type: 'required', message: 'Title is required' },
			{
				type: 'maxlength',
				message: 'Title should be less than 500 characters',
			},
		],
	},
	{
		type: 'text-editor',
		title: 'Post Description *',
		placeholder: 'Enter post description',
		formControlName: 'postDescription',
		required: true,

		errorsMsg: [{ type: 'required', message: 'Post description is required' }],
	},
	{
		type: 'datetime-local',
		title: 'Start Time* (Please use your local timezone)',
		placeholder: 'Start Date',
		formControlName: 'date',
		required: true,

		errorsMsg: [{ type: 'required', message: 'Start Time is required' }],
	},
	{
		type: 'toggle',
		title: 'Is LFA',
		formControlName: 'isLFA',
		size: 6,
	},
	{
		type: 'select',
		title:
			'Timezone (Use the timezone which corresponds to where the event is being organized.)',
		placeholder: 'Select timezone',
		formControlName: 'timeZone',
		required: true,
		errorsMsg: [{ type: 'required', message: 'select Timezone' }],
	},
	{
		type: 'select',
		title: 'Event Category *',
		placeholder: 'Event Category',
		formControlName: 'eventCategory',
		required: true,
		errorsMsg: [{ type: 'required', message: 'Event category is required' }],
	},
	{
		type: 'number',
		title: 'Price(Select only if the event is paid)',
		formControlName: 'price',
		placeholder: 'Enter price',
		errorsMsg: [{ type: 'pattern', message: 'Value cannot be negative' }],
	},
	{
		type: 'url',
		title: 'Zoom Link',
		formControlName: 'zoom',
		placeholder: 'Enter Zoom Link',

		errorsMsg: [{ type: 'pattern', message: 'Enter valid url' }],
	},
	{
		type: 'text',
		title: 'Location (for in person event)',
		formControlName: 'location',
		placeholder: 'Enter Location',
		maxLength: 200,
		errorsMsg: [
			{
				type: 'maxlength',
				message: 'Title should be less than 200 characters',
			},
		],
	},
	{
		type: 'url',
		title: 'Rsvp Link',
		formControlName: 'rsvp',
		placeholder: 'Enter Rsvp Link',

		errorsMsg: [{ type: 'pattern', message: 'Enter valid url' }],
	},
];
